import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import { Textarea } from "@repo/ui/Inputs/textarea";
import { type FC, useState } from "react";
import { Can } from "../../../../helpers/teammateAuthorizationContext.js";

export const MIN_TRAINING_MATERIALS_LENGTH = 20;
export const MAX_TRAINING_MATERIALS_LENGTH = 200000;

interface TrainingMaterialsTextAreaProps {
  value: string;
  onChange: (newValue: string) => void;
  description: string;
  errorText?: string;
  height?: string;
}

export const TrainingMaterialsTextArea: FC<TrainingMaterialsTextAreaProps> = ({
  value,
  onChange,
  errorText,
  description,
  height = "250px",
}) => {
  const [error, setError] = useState("");

  return (
    <Can
      I={PermissionActions.UPDATE}
      a={PermissionSubjects.JOB_OPENINGS}
      passThrough={true}
    >
      {(allowed) => (
        <Textarea
          label="Training materials"
          value={value}
          onChange={(newValue) => {
            setError(""); // Clear error on change
            onChange(newValue);
          }}
          onBlur={(evt) => {
            const newValue = evt.target.value;
            if (
              newValue.length > 0 &&
              newValue.length < MIN_TRAINING_MATERIALS_LENGTH
            ) {
              setError(
                `Training materials must be at least ${MIN_TRAINING_MATERIALS_LENGTH.toString()} characters long`,
              );
            } else if (newValue.length > MAX_TRAINING_MATERIALS_LENGTH) {
              setError(
                `Training materials must be less than ${MAX_TRAINING_MATERIALS_LENGTH.toString()} characters long`,
              );
            } else {
              setError("");
            }
          }}
          maxLength={MAX_TRAINING_MATERIALS_LENGTH}
          errorDescription={error || errorText}
          description={"Provide the content that employees will be trained on."}
          height={height}
          isDisabled={!allowed}
        />
      )}
    </Can>
  );
};
